/**
 * Description
 */
export interface EncodedUrl {
  readonly id: string;
  readonly userId: number;
  readonly inputUrl: string;
  readonly type: EncodedUrlType;
  readonly url: string;
}

export enum EncodedUrlType {
  URL_SAFE_ENCODE = 'url-safe-encode',
  USER_PROFILE = 'user-profile',
}
